import { Plugin } from "@nuxt/types";

/**
 * Axios accessor plugin.
 *
 * Initializes and provides the Axios instance to non component parts of the code base.
 *
 * @param {Context} context Nuxt context
 */
export const plugin: Plugin = context => {
    context.$axios.defaults.validateStatus = _ => true;
    context.$axios.interceptors.request.use(config => {
        if (context.app.$accessor.user.isLoggedIn) {
            const token = context.app.$accessor.user.token;
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    });
};

export default plugin;
